import PropTypes from 'prop-types'
import { createContext, useRef } from 'react'

import theme from 'theme'

export const AccordionContext = createContext()
export const AccordionProvider = AccordionContext.Provider

export default function Accordion({
  expanded,
  disabled = false,
  disableScrollAnimation = false,
  children,
  ...rest
}) {
  const accordionRef = useRef(null)

  return (
    <div
      ref={accordionRef}
      css={[
        {
          width: '100%',
          minHeight: theme.space[3],
          border: theme.border.base,
          borderRadius: theme.borderRadius[0],
          backgroundColor: theme.colors.panel[0]
        },

        Boolean(disabled) && {
          cursor: 'not-allowed',
          opacity: theme.opacity[0]
        }
      ]}
      {...rest}
    >
      <AccordionProvider
        value={{ expanded, disabled, disableScrollAnimation, accordionRef }}
      >
        {children}
      </AccordionProvider>
    </div>
  )
}

Accordion.propTypes = {
  expanded: PropTypes.bool,
  disabled: PropTypes.bool,
  disableScrollAnimation: PropTypes.bool,
  children: PropTypes.node
}
